const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	HEADER_HEIGHT: 70,
	TABLE_PAGE_SIZES: [15, 50, 100],
	DEFAULT_LANGUAGE: 'PL',
	ADMIN_DEFAULT_ROLE_ID: crypto.randomUUID(),
	DESCRIPTION_MAX_LENGTH: 1000,
	SESSION_STORAGE_KEYS: {
		REFRESH_TOKEN: 'refreshToken',
		USERS: {
			PAGE: 'users-page',
			LIMIT: 'users-limit',
			SEARCH: 'users-search',
			SORT: 'users-sort',
		},
		CONTENT: {
			PAGE: 'content-page',
			LIMIT: 'content-limit',
			SEARCH: 'content-search',
			SORT: 'content-sort',
		},
		NOTIFICATIONS: {
			PAGE: 'notifications-page',
			LIMIT: 'notifications-limit',
			SEARCH: 'notifications-search',
			SORT: 'notifications-sort',
		},
		PRODUCTS: {
			PAGE: 'products-page',
			LIMIT: 'products-limit',
			SEARCH: 'products-search',
			SORT: 'products-sort',
			FILTERS: 'products-filters',
		},
	},
	COUNTRIES: [
		'Polska',
		'Ukraina',
		'Rumunia',
		'Niemcy',
		'Francja',
		'Włochy',
		'Hiszpania',
		'Portugalia',
		'Holandia',
		'Belgia',
		'Szwajcaria',
		'Austria',
		'Czechy',
		'Słowacja',
		'Węgry',
		'Słowenia',
		'Chorwacja',
		'Grecja',
		'Bułgaria',
		'Turcja',
		'Litwa',
		'Łotwa',
		'Estonia',
	],
	ISO_639: [
		'ad',
		'al',
		'am',
		'at',
		'az',
		'ba',
		'be',
		'bg',
		'by',
		'ch',
		'cy',
		'cz',
		'de',
		'dk',
		'ee',
		'es',
		'fi',
		'fr',
		'gb',
		'ge',
		'gr',
		'hr',
		'hu',
		'ie',
		'is',
		'it',
		'kz',
		'li',
		'lt',
		'lu',
		'lv',
		'mc',
		'md',
		'me',
		'mk',
		'mt',
		'nl',
		'no',
		'pl',
		'pt',
		'ro',
		'rs',
		'ru',
		'se',
		'si',
		'sk',
		'sm',
		'tr',
		'ua',
		'us',
	],
} as const;

export default APP_CONFIG;
